import React from 'react';
import { BiChevronLeft } from "react-icons/bi";

const WalletHistory = () => {
  const transactions = [
    { description: 'Promotional Reward Added on Registration', amount: '₹500.00', positive: true },
    { description: 'Hanif (Referral)', amount: '₹200.00', positive: true },
    { description: 'Active 5g (Refund)', amount: '₹200.00', positive: true },
    { description: 'Ikhlas (Referral)', amount: '₹200.00', positive: true },
    { description: 'Top Up', amount: '₹200.00', positive: true },
    { description: 'Pulsar150 (Refund)', amount: '₹200.00', positive: false },
    { description: 'Ikhlas (Referral)', amount: '₹200.00', positive: true },
    { description: 'Mallik (Referral)', amount: '₹200.00', positive: true },
    { description: 'Harley', amount: '₹200.00', positive: false },
    { description: 'Ikhlas (Referral)', amount: '₹200.00', positive: true },
  ];

  return (
    <div className="w-full mx-auto p-4 bg-white rounded-lg border ">

      <div className="text-[#FF9630] font-semibold text-lg mb-4 flex items-center">
        <BiChevronLeft size={24} className="mr-1" /> Wallet History
      </div>
      <div className="space-y-4 ">
        {transactions.map((transaction, index) => (
          <div
            key={index}
            className="flex justify-between items-center p-3 border border-gray-200 rounded-lg"
          >
            <p className="text-[#FF9630] text-sm">{transaction.description}</p>
            <p
              className={`text-sm font-semibold ${transaction.positive ? 'text-green-600' : 'text-red-500'
                }`}
            >
              {transaction.amount}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WalletHistory;
